// extracted by mini-css-extract-plugin
module.exports = {"root":"SideBySide_root__OCKz2","side":"SideBySide_side__cprc9","left":"SideBySide_left__xoEAg","right":"SideBySide_right__9I6JV"};